// extracted by mini-css-extract-plugin
module.exports = {"container":"structured-columns_container__V6ceC","innerContainer":"structured-columns_innerContainer__s5bc_","title":"structured-columns_title__jP8UX"};